var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimeError = function SvgTimeError(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4246",
    d: "m9.013 9.905-2.95-1.767V4.094h1.313v3.299l2.31 1.391z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4246",
    d: "M7 .219A6.77 6.77 0 0 0 .656 4.638l.438-.167a3.6 3.6 0 0 1 1.181-.21 5.469 5.469 0 1 1 2.17 7.569c0 .452-.155.89-.437 1.242A6.772 6.772 0 1 0 7 .22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4246",
    d: "m2.791 10.063.429-4.376a2.7 2.7 0 0 0-.875-.13 2.6 2.6 0 0 0-.831.13l.42 4.376zM1.636 11.813a.753.753 0 1 0 .753-.753.76.76 0 0 0-.753.752"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimeError);
export default ForwardRef;